import { schema } from 'normalizr';

import { processMemberNetworks, processMultiTenantOrganization } from '../strategies/multiTenantOrganization';

const memberNetworksSchema: schema.Entity = new schema.Entity(
  'networks',
  {},
  { processStrategy: processMemberNetworks }
);

const memberNetworksEdgesSchema: schema.Object[] = [new schema.Object({ nodeId: memberNetworksSchema })];

export const multiTenantNetworkSchema: schema.Entity = new schema.Entity(
  'multiTenantOrganization',
  {
    networks: memberNetworksEdgesSchema,
  },
  {
    processStrategy: processMultiTenantOrganization,
  }
);
